import React, { Component } from "react";
import FlexView from "react-flexview";
import { monthOptions, yearOptions } from "../config";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import VariantSalesReport from "./variantSalesReport";
import Api from "../../../../../Services/Api";
import { mapToObjectDDL } from "../../../../common/mapper";
import Container from "../../../../../modules/commons/Container";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { connect } from "react-redux";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import moment from "moment";

class VariantReport extends Component {
  constructor(props) {
    super(props);
    this.currentMonth = Number(moment().format("MM"));
    this.currentYear = Number(moment().format("YYYY"));

    this.state = {
      loading: false,
      dataCabang: [],
      dataSales: [],
      kodeCabang: null,
      // sales: {
      //   value: this.props.user.user.employeeId,
      //   label: this.props.user.user.name,
      // },
      sales: null,
      month: monthOptions.find((item) => item.value === this.currentMonth),
      year: yearOptions.find((item) => item.value === this.currentYear),
      search: {
          month: monthOptions.find((item) => item.value === this.currentMonth)?.value,
          year: yearOptions.find((item) => item.value === this.currentYear)?.value,
      },
      doSearch: false,
    };
  }

  componentDidMount = async () => {
    this.fetchDataCabang();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  fetchDataCabang = async () => {
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      menuName: "Dashboard Level Salesman CS - Laporan Jual Varian",
      setError: this.props.setError,
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang)
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData?.map((item) =>
            mapToObjectDDL(item.namaDealer, item.kodeCabang)
          ),
          kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
        }));
        await this.fetchDataSales(filteredData[0].kodeCabang);
      }
    }
  };

  // fetchDataSales = async (value) => {
  //   let res = await fetchDataAsync({
  //     asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
  //     menuName: "Dashboard Level Salesman CS - Laporan Jual Varian",
  //     setError: this.props.setError,
  //     args: { paramFilters: { kodeCabang: value } },
  //   });
  //   if (res.ok && res.data.status === HttpStatus.SUCCESS) {
  //     this.setState((prevValue) => ({
  //       ...prevValue,
  //       dataSales: res.data.data,
  //     }));
  //   }
  // };

  handleSearchValueChange = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  handleChangeCabang = (value) => {
    this.handleSearchValueChange("kodeCabang", value);
    this.fetchDataSales(value?.value);
  };

  handleSearch = () => {
    let { kodeCabang, sales, month, year } = this.state;
    console.log(this.state);
    this.setState((prevValue) => ({
      ...prevValue,
      search: {
        kodeCabangList: [kodeCabang?.value],
        salesId: sales?.value,
        month: month?.value,
        year: year?.value,
        teamLeaderEmployeeId: this.props.user?.user?.employeeId,
        page: 1,
        limit: 10,
      },
      doSearch: true,
    }));
  };

  fetchDataSales = async (value) => {
    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA"
      ).getSalesDropdownForDashboard({
        employeeIdTeamLeader: this.props.user?.user?.employeeId,
        kodeCabang: value,
      });
      if (res.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataSales: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors", error);
    }
  };

  handleSetValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  render() {
    return (
      <>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleDDL
              id="select_options_kode_cabang"
              box="search"
              name="kodeCabang"
              containerclassname="width width-300px"
              placeholder="Nama Cabang"
              menuPosition="fixed"
              isClearable
              options={this.state.dataCabang}
              value={this.state.kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
            <SimpleDDL
              id="select_options_sales"
              box="search"
              name="sales"
              containerclassname="width width-250px"
              placeholder="Nama Sales"
              menuPosition="fixed"
              isClearable
              options={this.state.dataSales.map((item) =>
                mapToObjectDDL(item.name, item.employeeId)
              )}
              value={this.state.sales}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleDDL
              id="select_options_month"
              box="search"
              name="month"
              containerclassname="width width-150px"
              placeholder="Bulan"
              menuPosition="fixed"
              isClearable
              options={monthOptions}
              value={this.state.month}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleDDL
              id="select_options_year"
              box="search"
              name="year"
              containerclassname="width width-120px"
              placeholder="Tahun"
              menuPosition="fixed"
              isClearable
              options={yearOptions}
              value={this.state.year}
              onChange={(value, { name }) =>
                this.handleSearchValueChange(name, value)
              }
            />
            <SimpleButton
              styles={{ marginBottom: "15px" }}
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Jualan Per Varian</Tab>
              <Tab>Laporan Jualan Per Varian Year To Date</Tab>
            </TabList>
            <TabPanel>
              <VariantSalesReport
                {...this.props}
                tab="variant"
                search={this.state.search}
                doSearch={this.state.doSearch}
                handleSetValue={this.handleSetValue}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <VariantSalesReport
                {...this.props}
                tab="ytd"
                search={this.state.search}
                doSearch={this.state.doSearch}
                handleSetValue={this.handleSetValue}
                triggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
          </Tabs>
        </Container>
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VariantReport);
